// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Kz-z","tooltipWrapper":"Lz-z","icon":"Mz-z","tooltip":"Nz-z","content":"Oz-z"};